import { ListItem } from '@nrx/ui';
import type { JSX, ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router';

export interface NavListItemButtonProps {
  to: string;
  children: ReactNode;
  /** Nesting indent for section children. Defaults to 0 (top-level). */
  indent?: 0 | 1 | 2;
}

function isActivePath(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}

/**
 * Router-aware sidebar row using @nrx/ui list button styling.
 * Keeps react-router out of @nrx/ui while matching nrx-console active rules.
 */
export function NavListItemButton({
  to,
  children,
  indent = 0,
}: NavListItemButtonProps): JSX.Element {
  const { pathname } = useLocation();
  const active = isActivePath(pathname, to);

  return (
    <ListItem>
      <NavLink
        to={to}
        className={[
          'nrx-list-item-button',
          indent === 1 ? 'nrx-list-item-button--indent-1' : '',
          indent === 2 ? 'nrx-list-item-button--indent-2' : '',
          active ? 'nrx-list-item-button--active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-current={active ? 'page' : undefined}
      >
        {children}
      </NavLink>
    </ListItem>
  );
}
